import useNavbar from './useNavbar';

import useEditorDispatch from "./useEditorDispatch";
import React, { useState } from 'react';
import TemplatePositionLock from './TemplatePositionLock';
import CropFreeIcon from '@material-ui/icons/CropFree';
import Id from './IdFactory';
import PictureInPictureAltIcon from '@material-ui/icons/PictureInPictureAlt';
import Navbar from './Navbar';

const region = "region";

const defaultItemOrder = [
  {
    item:"text",
    icon: <div>Text</div>
  },
  {
    item:"scalebar",
    icon:(
      <div style={{textAlign:'center', borderBottom:'2px solid black', fontSize:8}}>
        µm
      </div>
    )
  },
  {
    item:region,
    icon:(<PictureInPictureAltIcon/>)
  }
].map(x => {
  let c1 = x.item[0];

  return ({
    ...x,
    _id:x.item,
    label:(c1.toUpperCase() + x.item.slice(1)),
  })
})

export default function NodeExpansionItemAdder({
  onEvent,
  figurePanelId,
}){



  let [ isAdding, setIsAdding ] = useState(region);

  const navbarConfig = {onChange:setIsAdding,options:defaultItemOrder}
  const [selected,navbar] = useNavbar(navbarConfig,isAdding);

  let addRegionArgs = true;//l//extras.find(x => x.type === "regionOutline");


  let addableItems = [
    ...defaultItemOrder,
  ]

  let regionAddButton = addRegionArgs && (
    <div>
      <button onClick={e => {

        let eventArgs = {
          event:e,
          type:"specifyExpansionNodeRegion",
          args:{
            ...addRegionArgs,

            onCompleteEventType:"addRegionOutline",
          },
          figurePanelId,
        }

        debugger;

        onEvent(eventArgs)

      }}>Region box</button>
      <CropFreeIcon />
    </div>
  )

  return (
    <div class="sg-col v-center" style={{
      textAlign:'center',
    }}>
      {navbar}
      <div class="sg-row">

        {false && addableItems.map(({item,icon}) => {
          let itemType = item;
          return (
            <div style={{fontSize:10}}>
              <button style={{fontSize:10}} onClick={() => {
                setIsAdding(itemType);
              }} button={`add-${itemType}`}>
                {itemType[0].toUpperCase() + itemType.slice(1)}
              </button>
              {icon}

            </div>
          )
        })}

        {false && regionAddButton}
      </div>

      {isAdding && (
        <TemplatePositionLock {...{
          external:(isAdding === "region"),
          onEvent:({event,position,relativeLocation,direction}) => {

            //we may not get a relative location...

            //let nodeArgs = { position };
            if( isAdding === "text" ){
              //nodeArgs.type = "text";
            }else if( isAdding === "region" ){
              debugger;
              //nodeArgs.value = { regionId:Id() }
            }

            let args = {
                type:isAdding,
              location:position,
                relativeLocation,
                direction,
              }

            if( isAdding === region ){
              args.regionId = Id();
            }

            onEvent({
              event,
              figurePanelId,
              type:"add",
              args,
            })

            setIsAdding(false);
          },


        }}/>
      )}
      
    </div>
  )




}
